var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MainLeftMenu.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0ba0fc8a\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MainLeftMenu.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./libs/@db2b/keystone/components/Templates/MainLeftMenu.vue
// module id = 621
// module chunks = 1